import { render } from "./DashboardCompletionProgress.vue?vue&type=template&id=2000b4f7&scoped=true&ts=true"
import script from "./DashboardCompletionProgress.vue?vue&type=script&lang=ts"
export * from "./DashboardCompletionProgress.vue?vue&type=script&lang=ts"

import "./DashboardCompletionProgress.vue?vue&type=style&index=0&id=2000b4f7&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2000b4f7"]])

export default __exports__